<template>
  <div class="line-item"  @mousemove="checkAreaHover" @mouseleave="coverageState.hoverAreaId = -1"> 
      <div class="heading ml-2" style="display:flex;" @click.stop.prevent="$store.myActions.UI_SET_MEASURETOOL('NONE');">           
        <v-btn class="mx-0" small icon @click.prevent="isVisible = !isVisible" :title="$t(isVisible?'Simulation.HideAreaTooltip':'Simulation.ShowAreaTooltip')"><v-icon>{{isVisible?'mdi-eye':'mdi-eye-off'}}</v-icon></v-btn>        
        <v-btn class="missionbtn mx-0 pr-2" flat @click.prevent="isOpen = !isOpen" :title="$t(isOpen?'Simulation.HideAreaMoreInfosTooltip':'Simulation.ShowAreaMoreInfosTooltip')" >          
          {{excludeArea.area_label}}           
          <v-icon :class="{rotate180:isOpen}" style="margin-left:auto">mdi-chevron-down</v-icon></v-btn>
          <v-btn class="ma-0" small icon @click="$emit('rename')"><v-icon>mdi-sort-alphabetical-descending-variant</v-icon></v-btn>
          <v-btn class="ma-0" small icon @click.prevent="showGlobalWaypoint()" :title="$t('Simulation.AddExcludePoint')"><v-icon >mdi-map-marker-plus</v-icon></v-btn>
          <v-btn class="my-0" small icon @click.prevent="deleteArea()" :title="$t('Simulation.DeleteArea')"><v-icon >mdi-delete</v-icon></v-btn>
      </div>
      <v-expand-transition>                
          <smart-coverage-wpt-list v-if="isOpen" :areaId="excludeArea.id" :key="excludeArea.id" :coverageState="coverageState" :wptList="excludeArea.area_pts"   />
      </v-expand-transition>
  </div>
</template>

<script lang="ts">      
  
  import SmartCoverageWptList from '@/components/smart/Coverage/WptList.vue'
  import { IArea } from '@/models/iris/smartMission/IArea'
  import { CoverageUiState } from '@/models/ui/CoverageUiState'  
  import Vue from 'vue'  
  import Component from 'vue-class-component'

  @Component({
    name: 'SmartCoverageExcludeArea', 
    components:{SmartCoverageWptList},
    props:{      
      excludeArea: Object,      
      coverageState: Object,       
    }
  })
  export default class SmartCoverageExcludeArea extends Vue {  
    
    excludeArea!:IArea
    coverageState!:CoverageUiState
    
    
    get isOpen() {
      return this.coverageState.editAreaId == this.excludeArea.id!
    }

    set isOpen(value) {
      this.coverageState.editAreaId = value?this.excludeArea.id!:-1
    }      

    get isVisible() {
      return !this.coverageState.areaHidden[this.excludeArea.id!] 
    }    
    set isVisible(value) {
      this.$set(this.coverageState.areaHidden,this.excludeArea.id!,!value)
    }

    checkAreaHover(event:any) {    
      if (!event.target) return
      const item = event.target.closest('.line-item')      
      if (item) this.coverageState.hoverAreaId = this.excludeArea.id!
      else this.coverageState.hoverAreaId = -1               
    }

    showGlobalWaypoint() {      
      this.coverageState.editAreaId = this.excludeArea.id!
      this.coverageState!.showGlobalWpts = true
    }

    deleteArea() {
      this.$confirm(this.$t('Simulation.ConfirmDeleteAreaMessage').toString()).then(remove => {      
        if(remove) {                            
          this.$emit("delete")
        }
      })    
    }
   
  
  }
</script>